var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledCog24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Admin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/cog_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cog",
    transform: "translate(-0.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.1114688,9.90583501 L13.7400402,9.1138833 C13.8784708,8.36700201 13.8784708,7.60080483 13.7400402,6.85392354 L15.1114688,6.06197183 C15.2692153,5.97183099 15.3400402,5.78511066 15.2885312,5.61126761 C14.9311871,4.46519115 14.3227364,3.42857143 13.5275654,2.56579477 C13.4052314,2.43380282 13.2056338,2.40160966 13.0511066,2.4917505 L11.6796781,3.28370221 C11.1034205,2.78792757 10.4402414,2.40482897 9.722334,2.15372233 L9.722334,0.573038229 C9.722334,0.392756539 9.59678068,0.23501006 9.41971831,0.19637827 C8.23822938,-0.0676056338 7.0277666,-0.0547283702 5.90422535,0.19637827 C5.72716298,0.23501006 5.60160966,0.392756539 5.60160966,0.573038229 L5.60160966,2.15694165 C4.88692153,2.41126761 4.22374245,2.7943662 3.64426559,3.28692153 L2.27605634,2.49496982 C2.11830986,2.40482897 1.92193159,2.43380282 1.79959759,2.56901408 C1.00442656,3.42857143 0.395975855,4.46519115 0.0386317907,5.61448692 C-0.0160965795,5.78832998 0.0579476861,5.9750503 0.215694165,6.06519115 L1.58712274,6.85714286 C1.44869215,7.60402414 1.44869215,8.37022133 1.58712274,9.11710262 L0.215694165,9.90905433 C0.0579476861,9.99919517 -0.0128772636,10.1859155 0.0386317907,10.3597586 C0.395975855,11.505835 1.00442656,12.5424547 1.79959759,13.4052314 C1.92193159,13.5372233 2.12152918,13.5694165 2.27605634,13.4792757 L3.64748491,12.6873239 C4.22374245,13.1830986 4.88692153,13.5661972 5.60482897,13.8173038 L5.60482897,15.4012072 C5.60482897,15.5814889 5.73038229,15.7392354 5.90744467,15.7778672 C7.0889336,16.0418511 8.29939638,16.0289738 9.42293763,15.7778672 C9.6,15.7392354 9.72555332,15.5814889 9.72555332,15.4012072 L9.72555332,13.8173038 C10.4402414,13.5629779 11.1034205,13.1798793 11.6828974,12.6873239 L13.054326,13.4792757 C13.2120724,13.5694165 13.4084507,13.5404427 13.5307847,13.4052314 C14.3259557,12.545674 14.9344064,11.5090543 15.2917505,10.3597586 C15.3400402,10.1826962 15.2692153,9.99597586 15.1114688,9.90583501 Z M7.66197183,10.5593561 C6.24225352,10.5593561 5.08651911,9.40362173 5.08651911,7.98390342 C5.08651911,6.56418511 6.24225352,5.4084507 7.66197183,5.4084507 C9.08169014,5.4084507 10.2374245,6.56418511 10.2374245,7.98390342 C10.2374245,9.40362173 9.08169014,10.5593561 7.66197183,10.5593561 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledCog24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_cog_24px.356908c0.svg";
export { ForwardRef as ReactComponent };